import React, { useState } from "react";
import { loginAdmin } from "../../api/adminAuthApi";
import logo from "../../assets/images/logo.png";
import "./login.scss";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      setErrorMessage("Please enter your email address and password.");
      return;
    }

    setErrorMessage("");
    setIsSubmitting(true);

    try {
      await loginAdmin(email.trim(), password);
      window.location.replace("/admin");
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-page__card">
        <div className="login-page__brand">
          <img className="login-page__logo" src={logo} alt="" />
          <strong>SecondBite</strong>
          <small>Admin Portal</small>
        </div>

        <h1 className="login-page__title">Welcome Back</h1>
        <p className="login-page__subtitle">Login to manage merchants, orders, and reports</p>

        <form className="login-page__form" onSubmit={handleLogin}>
          <div className="login-page__field">
            <span className="login-page__icon"><i className="ti ti-user" aria-hidden="true"></i></span>
            <input
              className="login-page__input"
              type="email"
              placeholder="Email Address"
              value={email}
              autoComplete="username"
              onChange={(e) => {
                setEmail(e.target.value);
                setErrorMessage("");
              }}
              disabled={isSubmitting}
            />
          </div>

          <div className="login-page__field">
            <span className="login-page__icon"><i className="ti ti-lock" aria-hidden="true"></i></span>
            <input
              className="login-page__input"
              type="password"
              placeholder="Password"
              value={password}
              autoComplete="current-password"
              onChange={(e) => {
                setPassword(e.target.value);
                setErrorMessage("");
              }}
              disabled={isSubmitting}
            />
          </div>

          {errorMessage && (
            <div className="login-page__message login-page__message--error">
              {errorMessage}
            </div>
          )}

          <button type="submit" className="login-page__submit" disabled={isSubmitting}>
            {isSubmitting ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>

      <div className="login-page__wave login-page__wave--one" />
      <div className="login-page__wave login-page__wave--two" />
    </div>
  );
};

export default LoginPage;
